import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css';
import './i18n';
import * as serviceWorker from './serviceWorker';
import { createGlobalStyle } from 'styled-components';
import { ApolloProvider } from '@apollo/client';
import createClient from './apollo/createClient';
import EnvironmentVariableProvider from './EnvironmentVariableProvider';
import EnsureHealthyStatus from './components/EnsureHealthyStatus';
import AnalyticsProvider from './AnalyticsProvider';
import AppThemeProvider from "./AppThemeProvider"
import App from './App';
import Loading from './Loading';

// Will fix probe-image-size that expects to find "captureStackTrace" which
// is only available in a node environment and doesn't exists in browsers.
Error.captureStackTrace = Error.captureStackTrace !== undefined
  ? Error.captureStackTrace
  : console.trace;

const client = createClient();

const GlobalStyle = createGlobalStyle`
  * { box-sizing: border-box }

  * {
    outline: none; // @todo 2020-04-23 enabled when needed
  }

  html, body {
    margin: 0;
    padding: 0;

    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif;
    line-height: 1.375;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    flex: 1;
    display: flex;
    flex-direction: column;

    background-color: #000;
  }

  a,
  a:visited {
    color: inherit;
  }

  @media screen and (max-width: 1200px) and (max-height: 750px) {
    html {
      font-size: 90%;
    }
  }

  @media screen and (max-width: 768px) and (max-height: 500px) {
    html {
      font-size: 70%;
    }
  }

  button {
    line-height: inherit;
  }

  #root {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`;

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <GlobalStyle/>
      <Suspense fallback={<Loading />}>
        <EnvironmentVariableProvider>
          <AppThemeProvider>
            <EnsureHealthyStatus>
              <AnalyticsProvider>
                <App/>
              </AnalyticsProvider>
            </EnsureHealthyStatus>
          </AppThemeProvider>
        </EnvironmentVariableProvider>
      </Suspense>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
